var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createClient, createConfig } from "@hey-api/client-fetch";
import { getGoogleReCaptchaToken } from "@jti/fe-clients";
import { sanitizeBaseUrl } from "../../../utils";
import { createActionVerification, findActionVerificationItem, verifyActionVerification, } from "../../evo-client/__generated__";
import { getIsStatusValidated } from "../utils";
const PHONE_VERIFICATION_CHANNEL = "sms";
export class PvsApiEvo {
    constructor(baseUrl, tenantToken, recaptchaId) {
        this.tenantToken = tenantToken;
        this.recaptchaId = recaptchaId;
        this.client = createClient(createConfig({ baseUrl: sanitizeBaseUrl(baseUrl), throwOnError: true }));
    }
    initPhoneValidationByOtp(phone_1) {
        return __awaiter(this, arguments, void 0, function* (phone, otpChannel = "sms") {
            var _a, _b;
            const recaptchaToken = yield getGoogleReCaptchaToken(this.recaptchaId);
            const { data } = yield createActionVerification({
                client: this.client,
                headers: {
                    "X-DES-TENANT": this.tenantToken,
                    // NOTE: It was added manually due to BE missing this header in API contract
                    "X-DES-RECAPTCHA-TOKEN": recaptchaToken,
                },
                body: {
                    channel: otpChannel || PHONE_VERIFICATION_CHANNEL,
                    identifier: phone,
                },
            });
            return Promise.resolve({
                uuid: (_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.uuid) !== null && _b !== void 0 ? _b : "",
                hash: "", // hash is not longer required
            });
        });
    }
    verifyOtp(phoneVerificationUuid, code) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const recaptchaToken = yield getGoogleReCaptchaToken(this.recaptchaId);
            const { data, response } = yield verifyActionVerification({
                client: this.client,
                headers: {
                    "X-DES-TENANT": this.tenantToken,
                    "X-DES-RECAPTCHA-TOKEN": recaptchaToken,
                },
                path: {
                    uuid: phoneVerificationUuid,
                },
                body: {
                    code,
                },
            });
            return Promise.resolve({
                uuid: (_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.uuid) !== null && _b !== void 0 ? _b : "",
                statusCode: response.status,
                is_verified: getIsStatusValidated((_c = data === null || data === void 0 ? void 0 : data.data) === null || _c === void 0 ? void 0 : _c.status),
                verification_performed: true,
            });
        });
    }
    /***
     * @deprecated
     * only used in the dead code at this point in time - might be removed in the future
     */
    verifyEmailOtp(uuid, code) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const recaptchaToken = yield getGoogleReCaptchaToken(this.recaptchaId);
            const { data, response } = yield verifyActionVerification({
                client: this.client,
                headers: {
                    "X-DES-TENANT": this.tenantToken,
                    "X-DES-RECAPTCHA-TOKEN": recaptchaToken,
                },
                path: {
                    uuid,
                },
                body: {
                    code,
                },
            });
            return {
                uuid: (_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.uuid) !== null && _b !== void 0 ? _b : "",
                statusCode: response.status,
                is_verified: getIsStatusValidated((_c = data === null || data === void 0 ? void 0 : data.data) === null || _c === void 0 ? void 0 : _c.status),
                verification_performed: true,
            };
        });
    }
    checkVerificationStatus(uuid) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const { data } = yield findActionVerificationItem({
                client: this.client,
                headers: {
                    "X-DES-TENANT": this.tenantToken,
                },
                path: {
                    uuid,
                },
            });
            return Promise.resolve({
                uuid: (_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.uuid) !== null && _b !== void 0 ? _b : "",
                is_verified: getIsStatusValidated((_c = data === null || data === void 0 ? void 0 : data.data) === null || _c === void 0 ? void 0 : _c.status),
                verification_sent: true,
            });
        });
    }
}
//# sourceMappingURL=PvsApiEvo.js.map